import { useFeatureIsOn } from '@growthbook/growthbook-react'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Prompt, useHistory, useParams } from 'react-router-dom'
import { Row, Col, Space, Spin, Tooltip, message, notification } from 'antd'
// import { SiderLayout } from 'modules/core/layouts'
import {
  ActionModal,
  Button,
  CreationExitModal,
  // DateAndDimensionFilters,
  KPIsGlobalDetail,
  // PeriodNavigator,
  ProjectionSelects,
  ScreenWellDone,
  ToolsDrawer,
  UserActionsGlobalDetail,
} from 'modules/core/components'
import { TabsReports } from './components'
import { useTranslation } from 'react-i18next'
import {
  generateMessageError,
  getBudgetSelected,
  getOperationsByKeys,
  getStepsOfInstances,
  isApproved,
  isPublished,
  isUserAllowed,
  sendUserDataToGTM,
} from 'modules/core/utils'
import { ROLES, PROJECTION, GENERAL, TAB_KEYS } from 'modules/core/constants'
import { client } from 'httpclient'
import { onSetDefaultBudget } from './util'
import { useDefaultCurrency } from 'modules/core/customHooks'
import imageDefault from 'assets/images/compositions/feedback-image.svg'
import reports from 'modules/reports'
import planning from 'modules/planning'
import configuration from 'modules/configuration'
import login from 'modules/login'
import PropTypes from 'prop-types'

import './GlobalBudgetDetail.scss'
import control from 'modules/control'
import _ from 'lodash'
import CheckBalanceModal from 'modules/core/components/ProjectionComponents/CheckBalanceModal/CheckBalanceModal'

const { PLANNING__GLOBAL_BUDGET__ABM, SETTINGS__PROJECTION_ELEMENTS__BUSINESS_RULES } = ROLES

const GlobalBudgetDetail = ({
  isScreenLoading,
  globalBudgetDetail,
  onRefresh,
  fetchBudgetTypeList,
  analysisList,
  fetchAnalysisList,
  approveGlobalBudget,
  setDefaultBudget,
  publishGlobalBudget,
  // fetchGlobalBudgetDetail,
  periodList,
  changeBudget,
  fetchDataEvolutionByOverallBudget,
  fetchDataComparativeByOverallBudget,
  applyRule,
  unApplyRule,
  fetchAllDimensions,
  allDimensionsList,
  fetchCurrencyList,
  currencyList,
  fetchCommentsList,
  commentsList,
  fetchGlobalBudgetKpi,
  globalBudgetKpi,
  tabKey,
  setTabKey,
  applyUnappluMassiveGlobalBudget,
  loggedUser,
  shareLayout,
}) => {
  const enableKpis = useFeatureIsOn('feature-visible-kpi')
  let { periodId, globalBudgetId, currency, reportId, base, tableType } = useParams()
  const [isBudgetLoading, setIsBudgetLoading] = useState(false)
  const [tableId, setTableId] = useState(reportId || null)
  const [showActionModal, setShowActionModal] = useState(null)
  const [showScreenSuccess, setShowScreenSuccess] = useState(null)
  const [selectedDates] = useState({})
  const [filters] = useState({})
  const [options, setOptions] = useState([])
  const [showDrawerRules, setShowDrawerRules] = useState(false)
  const [isTableLoading, setIsTableLoading] = useState(false)
  const [defaultPhase, setDefaultPhase] = useState(base || PROJECTION.BASE_KEY)
  const [isCurrencyLoading, setIsCurrencyLoading] = useState(false)
  const [currencyChange, setCurrencyChange] = useState(null)
  const [dataComments, setDataComments] = useState([])
  const [isLoadingComments, setIsLoadingComments] = useState(false)
  const [applyRuleB, setApplyRuleB] = useState(false)
  const [showProgressBar, setShowProgressBar] = useState(false)
  const [isKpiLoading, setIsKpiLoading] = useState(false)
  const [showExitModal, setShowExitModal] = useState(false)
  const [lastLocation, setLastLocation] = useState(null)
  const [confirmedNavigation, setConfirmedNavigation] = useState(false)
  const [showAlert, setShowAlert] = useState({
    kpi: false,
    comparison: false,
    evolution: false,
    chart: false,
    rule: false,
    exchangeRate: false,
  })
  const [settingsEvolution, setSettingsEvolution] = useState({})
  const [settingsComparison, setSettingsComparison] = useState({})
  const [tableKey, setTableKey] = useState(tableType || TAB_KEYS.TAB_KEY_EVOLUTION)
  const [showBalanceModal, setShowBalanceModal] = useState(false)

  const defaultCurrencyData = useDefaultCurrency()
  let history = useHistory()
  const { t } = useTranslation()

  const auxCurrencyId = currencyChange ? currencyChange : defaultCurrencyData?.id
  const key = window.location.pathname.replaceAll('/', '-')
  const currencyData = currencyChange
    ? currencyList.data.find((el) => el.id === currencyChange)
    : defaultCurrencyData

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault()
      window.confirm('Puede que haya cambios sin guardar, deseas volver atrás?')
    }

    if (
      showAlert.comparison ||
      showAlert.kpi ||
      showAlert.evolution ||
      showAlert.chart ||
      showAlert.rule ||
      showAlert.exchangeRate
    ) {
      window.addEventListener('beforeunload', handleBeforeUnload)
    }

    if (
      !showAlert.comparison &&
      !showAlert.kpi &&
      !showAlert.evolution &&
      !showAlert.chart &&
      !showAlert.rule &&
      !showAlert.exchangeRate
    ) {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [
    showAlert.kpi,
    showAlert.comparison,
    showAlert.evolution,
    showAlert.chart,
    showAlert.exchangeRate,
    showAlert.rule,
  ])

  useEffect(() => {
    if ((currency && currencyChange) || (!currency && currencyChange)) {
      setCurrencyChange(auxCurrencyId)
    } else {
      setCurrencyChange(parseInt(currency))
    }
  }, [currency, auxCurrencyId, currencyChange])

  useEffect(() => {
    setIsLoadingComments(true)
    fetchCommentsList({ module: key }).then(() => setIsLoadingComments(false))
  }, [fetchCommentsList, key])

  useEffect(() => {
    setDataComments(commentsList)
  }, [commentsList])

  // useEffect(() => {
  //   setIsScreenLoading(true)
  //   fetchGlobalBudgetDetail(globalBudgetId).then(() => setIsScreenLoading(false))
  //   return () => setIsScreenLoading(false)
  // }, [fetchGlobalBudgetDetail, globalBudgetId])

  useEffect(() => {
    fetchAnalysisList().then((data) => {
      if (data.payload.data.length > 0) {
        if (reportId) {
          setTableId(reportId)
        } else {
          setTableId(data.payload.data[0].id)
        }
      }
    })
  }, [fetchAnalysisList, reportId])

  useEffect(() => {
    fetchAllDimensions()
  }, [fetchAllDimensions])

  useEffect(() => {
    if (currencyData) {
      setIsKpiLoading(true)
      fetchGlobalBudgetKpi(periodId, globalBudgetId, {
        budget_type: 'planning',
        currency_id: currencyData.id,
      }).then(() => {
        setIsKpiLoading(false)
      })
    }
  }, [fetchGlobalBudgetKpi, periodId, globalBudgetId, currencyData])

  //todo: revisar
  useEffect(() => {
    const fetchBudgetData = async () => {
      try {
        const response = await fetchBudgetTypeList()
        const concepts = response.payload.data.concepts

        for (const concept of concepts) {
          setIsBudgetLoading(true)

          const response = await client.get(`/planning/get_all/${concept.id}/${periodId}/`)

          const aux = response.data.results.map((budget) => ({
            ...budget,
            conceptId: concept.id,
          }))

          setOptions((prevState) => [...prevState, ...aux])
          setIsBudgetLoading(false)
        }
      } catch (error) {
        console.error('Error fetching budget data:', error)
        setIsBudgetLoading(false)
      }
    }

    fetchBudgetData()

    return () => {
      setIsBudgetLoading(false)
      setOptions([])
    }
  }, [fetchBudgetTypeList, periodId])

  useEffect(() => {
    setIsCurrencyLoading(true)
    fetchCurrencyList().then(() => {
      setIsCurrencyLoading(false)
    })
  }, [fetchCurrencyList])

  const isGlobalBudgetApproved = isApproved(globalBudgetDetail?.status)
  const isGlobalBudgetPublished = isPublished(globalBudgetDetail?.status)
  const isActionApprove = isApproved(showActionModal)
  const userCanAction = isUserAllowed(PLANNING__GLOBAL_BUDGET__ABM)
  const userCanViewAndABMRules = isUserAllowed(
    getOperationsByKeys([SETTINGS__PROJECTION_ELEMENTS__BUSINESS_RULES]),
  )
  const dataPeriod = periodList.find((el) => el.id === parseInt(periodId))
  const notBudgetClosed = getBudgetSelected(globalBudgetDetail?.budgets_ids, options)
    ? getBudgetSelected(globalBudgetDetail?.budgets_ids, options).some((el) => !el?.is_closing)
    : true

  const renderSelectors = () => (
    <ProjectionSelects
      loading={isBudgetLoading}
      idsBudgetsSelected={globalBudgetDetail?.budgets_ids}
      disabled={isGlobalBudgetApproved}
      options={options}
      globalProjectionId={globalBudgetId}
      changeProjection={changeBudget}
      onRefetchGobalBudgetDetail={onRefetchAll}
    />
  )

  const onRefetchAll = () => {
    setIsKpiLoading(true)
    setShowAlert((prevState) => {
      return { ...prevState, evolution: true, comparison: true, kpi: true }
    })
    Promise.all([
      onRefetch(),
      onRefresh(),
      fetchGlobalBudgetKpi(periodId, globalBudgetId, {
        budget_type: 'planning',
        currency_id: currencyData.id,
      }),
    ]).then(() => {
      setIsKpiLoading(false)
      setShowAlert((prevState) => {
        return { ...prevState, evolution: false, comparison: false, kpi: false }
      })
    })
  }

  const handleClick = (key) => {
    setCurrencyChange(key)
    window.history.replaceState(
      null,
      '',
      `/planificacion/${periodId}/presupuestoglobal/${globalBudgetId}/${tabKey}/${key}`,
    )
  }

  const handleOnClickCompartir = () => {
    const dataSettings = {
      ...(tableKey === 'evolution' && {
        ...settingsEvolution,
      }),
      ...(tableKey === 'comparison' && {
        ...settingsComparison,
      }),
    }

    const extraKey = tableKey === 'evolution' ? 'montly_evolution' : 'coparations'

    const {
      aggregatorName,
      cols,
      columns,
      default_format,
      default_value,
      rendererName,
      vals,
      valueFilter,
      rows,
    } = dataSettings

    const dataTable = {
      ...(!_.isEmpty(dataSettings) && {
        aggregatorName,
        cols,
        columns,
        default_format,
        default_value,
        rendererName,
        vals,
        valueFilter,
        rows,
      }),
    }

    const urlObj = new URL(window.location.href)
    const pathAndQuery = urlObj.pathname + urlObj.search

    shareLayout('overallbudget', `${globalBudgetId}-${tableId}-${extraKey}`, {
      path: pathAndQuery,
      config: { ...dataTable },
    })
      .then((response) => {
        message.success(t('FEEDBACK_COPY_URL_SUCCESS'), 8)
        const newUrl = response.payload.data.url_hash
        // .replace(
        //   'https://stg.getplika.com/',
        //   'http://localhost:3000/',
        // )
        navigator.clipboard.writeText(newUrl)
      })
      .catch((error) => {
        notification.error({
          message: t('FEEDBACK_DEFAULT_ERROR'),
          description: generateMessageError(error),
          duration: 0,
        })
      })
  }

  const renderUserActions = () => (
    <UserActionsGlobalDetail
      onClickPublish={() => setShowActionModal(PROJECTION.STATUS.PUBLISHED)}
      disabledPublish={isGlobalBudgetPublished || isGlobalBudgetApproved || !userCanAction}
      buttonPublishName={isGlobalBudgetPublished ? t('STATE_TAG_PUBLISHED') : t('ACTION_PUBLISH')}
      tooltipApprove={
        !isGlobalBudgetPublished && !isGlobalBudgetApproved ? t('TOOLTIP_NOT_APPROVE_TITLE') : ''
      }
      onClickApprove={() => setShowActionModal(PROJECTION.STATUS.APPROVED)}
      disableApprove={
        !userCanAction || isGlobalBudgetApproved || !isGlobalBudgetPublished || notBudgetClosed
      }
      buttonApproveName={isGlobalBudgetApproved ? t('STATE_TAG_APPROVED') : t('ACTION_APPROVE')}
      onClickApply={() => setShowDrawerRules(true)}
      extraButtons={{
        module_name: 'planning_global',
        submodule_name: globalBudgetId,
      }}
      currencyOptions={currencyList.data}
      onChangeCurrency={(val) => handleClick(val)}
      defaultCurrency={currencyChange ? currencyChange : defaultCurrencyData?.id}
      onClickActivity={() =>
        history.push(
          `/planificacion/${periodId}/presupuestoglobal/${globalBudgetId}/${tabKey}/${
            currencyChange
              ? currencyList.data.find((el) => el.id === currencyChange)?.id
              : defaultCurrencyData?.id
          }/${tableId}/evolution/base/actividad?type=planning_overall_budget&module=globalBudgetDetail`,
        )
      }
      onClickCompartir={() => handleOnClickCompartir()}
      setShowBalanceModal={setShowBalanceModal}
      onClickCommittedBalance={() =>
        history.push(`/planificacion/${periodId}/presupuestoglobal/${globalBudgetId}/comprometido`)
      }
    />
  )

  const renderReportsTables = () => (
    <TabsReports
      tableId={tableId}
      setTableId={setTableId}
      loading={isScreenLoading}
      stepsBudgetInstance={getStepsOfInstances(globalBudgetDetail, options)}
      dataPeriod={dataPeriod}
      globalBudgetName={globalBudgetDetail?.name}
      selectedDates={selectedDates}
      filters={filters}
      tableLoading={isTableLoading}
      allDimensionsList={allDimensionsList}
      defaultPhase={defaultPhase}
      setDefaultPhase={setDefaultPhase}
      auxCurrencyId={auxCurrencyId}
      setDataComments={setDataComments}
      dataComments={dataComments}
      onRefetchComments={() => fetchCommentsList({ module: key })}
      loadingComments={isLoadingComments}
      currencyData={
        currencyChange
          ? currencyList.data.find((el) => el.id === currencyChange)
          : defaultCurrencyData
      }
      showProgressBar={showProgressBar}
      setShowProgressBar={setShowProgressBar}
      isGlobalBudgetApproved={isGlobalBudgetApproved}
      tabKey={tabKey}
      settingsComparison={settingsComparison}
      settingsEvolution={settingsEvolution}
      setSettingsComparison={setSettingsComparison}
      setSettingsEvolution={setSettingsEvolution}
      tableKey={tableKey}
      setTableKey={setTableKey}
    />
  )

  const onRefetch = () => {
    setIsTableLoading(true)
    setShowProgressBar(true)
    setShowAlert((prevState) => {
      return { ...prevState, evolution: true, comparison: true }
    })
    Promise.all([
      fetchDataEvolutionByOverallBudget(tableId, parseInt(globalBudgetId), defaultPhase, {
        ...(auxCurrencyId && { currency_id: auxCurrencyId }),
      }),
      fetchDataComparativeByOverallBudget(tableId, parseInt(globalBudgetId), {
        ...(auxCurrencyId && { currency_id: auxCurrencyId }),
      }),
    ]).then(() => {
      setIsTableLoading(false)
      setShowAlert((prevState) => {
        return { ...prevState, evolution: false, comparison: false }
      })
      setTimeout(() => {
        setShowProgressBar(false)
      }, 2000)
    })
  }

  const handleClose = () => {
    setShowDrawerRules(false)
    if (applyRuleB) {
      console.log('applyRule', applyRuleB)
      onRefetch()
    }
    setApplyRuleB(false)
  }

  const handleApplyRule = (ruleId) => {
    setApplyRuleB(true)

    return applyRule(globalBudgetId, ruleId, { period: periodId })
  }

  const handleUnApplyRule = (ruleId) => {
    setApplyRuleB(true)

    return unApplyRule(globalBudgetId, ruleId, { period: periodId })
  }

  const handleExitConfirm = () => {
    if (lastLocation) {
      setShowExitModal(false)
      history.push(lastLocation)
      setShowAlert({
        kpi: false,
        comparison: false,
        evolution: false,
        chart: false,
        rule: false,
        exchangeRate: false,
      })
    } else {
      setShowAlert({
        kpi: false,
        comparison: false,
        evolution: false,
        chart: false,
        rule: false,
        exchangeRate: false,
      })
      history.push(`/planificacion/${periodId}/${PROJECTION.GLOBAL_BUDGET}`)
    }
  }

  const handleBlockedNavigation = (nextLocation) => {
    if (!confirmedNavigation) {
      setShowExitModal(true)
      setLastLocation(nextLocation)
      setConfirmedNavigation(true)
      setShowAlert({
        kpi: false,
        comparison: false,
        evolution: false,
        chart: false,
        rule: false,
        exchangeRate: false,
      })
      return false
    } else {
      setShowAlert({
        kpi: false,
        comparison: false,
        evolution: false,
        chart: false,
        rule: false,
        exchangeRate: false,
      })
      return true
    }
  }

  return (
    <div className="container-global-budget-detail">
      <Prompt
        when={
          showAlert.kpi ||
          showAlert.comparison ||
          showAlert.evolution ||
          showAlert.chart ||
          showAlert.rule ||
          showAlert.exchangeRate
        }
        message={handleBlockedNavigation}
      />
      <Spin spinning={isScreenLoading} />
      {globalBudgetDetail && !isScreenLoading && (
        <>
          {!showScreenSuccess && (
            <>
              <Row gutter={[8, 24]}>
                <Col span={24}>{renderUserActions()}</Col>
                <Col span={24}>{renderSelectors()}</Col>
                <Col span={24}>
                  {enableKpis && (
                    <KPIsGlobalDetail
                      globalBudgetKpi={globalBudgetKpi}
                      setDataComments={setDataComments}
                      dataComments={dataComments}
                      onRefetchComments={() => fetchCommentsList({ module: key })}
                      loadingComments={isLoadingComments}
                      currencyData={
                        currencyChange
                          ? currencyList.data.find((el) => el.id === currencyChange)
                          : defaultCurrencyData
                      }
                      isKpiLoading={isKpiLoading}
                    />
                  )}
                </Col>
                <Col span={24}>{analysisList.count > 0 && renderReportsTables()}</Col>
              </Row>
              <ActionModal
                globalBudgetId={globalBudgetId}
                isActionApprove={isActionApprove}
                visible={showActionModal}
                onAction={isActionApprove ? approveGlobalBudget : publishGlobalBudget}
                onFetchDetail={onRefresh}
                onConfirm={() => setShowScreenSuccess(showActionModal)}
                onClose={() => setShowActionModal(null)}
                sendUserDataToGTM={() =>
                  sendUserDataToGTM(
                    loggedUser,
                    'Presupuesto global',
                    `${isActionApprove ? 'Aprobar' : 'Publicar'} presupuesto global`,
                    `${isActionApprove ? 'Aprobación' : 'Publicación'}`,
                  )
                }
              />
              <ToolsDrawer
                onRefetchDataTable={onRefetch}
                periodId={periodId}
                visible={showDrawerRules}
                onClose={() => handleClose()}
                globalProjectionId={globalBudgetId}
                type="planning_overall_budget"
                applyRule={(ruleId) => handleApplyRule(ruleId)}
                unApplyRule={(ruleId) => handleUnApplyRule(ruleId)}
                typeModule={GENERAL.MODULES_KEYS.MODULE_PLANNING_OVERALL}
                moduleId={globalBudgetId}
                hasRule={true}
                hasCurrency={true}
                isCurrencyLoading={isCurrencyLoading}
                currencyList={currencyList}
                params={{
                  overall_budget_id: globalBudgetId,
                  module: 'OVERALL_PLANNING',
                }}
                disabledRule={!userCanViewAndABMRules || isGlobalBudgetApproved}
                disabledCurrency={!userCanAction || isGlobalBudgetApproved}
                setShowAlert={setShowAlert}
                applyUnappluMassive={applyUnappluMassiveGlobalBudget}
                extraDataApplyUnapply={{
                  card_id: globalBudgetId,
                }}
                setApplyRuleB={setApplyRuleB}
              />
            </>
          )}
          {showScreenSuccess && (
            <ScreenWellDone
              image={imageDefault}
              title={t('FEEDBACK_WELLDONE')}
              description={t('PLANNING_SCREEN_SUCCESS_FEEDBACK', {
                period: dataPeriod?.name,
                action: isActionApprove
                  ? t('ACTION_APPROVE').toLowerCase()
                  : t('ACTION_PUBLISH').toLowerCase(),
              })}
              footer={
                <Space>
                  <Button.Primary
                    onClick={() => setShowScreenSuccess(null)}
                    title="ACTION_FINISH"
                  />
                  {!isGlobalBudgetApproved && (
                    <Tooltip title={t('PLANNING_GLOBAL_BUDGET_INFORMATIVE_TOOLTIP_TITLE')}>
                      <Button.Default
                        onClick={() =>
                          onSetDefaultBudget({
                            setDefaultBudget: () => setDefaultBudget(globalBudgetId),
                            setShowScreenSuccess,
                            sendUserDataToGTM: () =>
                              sendUserDataToGTM(
                                loggedUser,
                                'Presupuesto global',
                                `Fijar presupuesto global`,
                                `Fijación`,
                              ),
                          })
                        }
                        title="ACTION_FIX"
                      />
                    </Tooltip>
                  )}
                </Space>
              }
            />
          )}
          <CreationExitModal
            visible={showExitModal}
            onClose={() => {
              setShowExitModal(false)
              setConfirmedNavigation(false)
              setShowAlert({
                kpi: false,
                comparison: false,
                evolution: false,
                chart: false,
                rule: false,
                exchangeRate: false,
              })
            }}
            onConfirm={handleExitConfirm}
          />
          <CheckBalanceModal
            open={showBalanceModal}
            onClose={() => setShowBalanceModal(false)}
            id={globalBudgetId}
          />
        </>
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  // globalBudgetDetail: planning.selectors.getGlobalBudgetDetail(state),
  analysisList: reports.selectors.getAnalysisList(state),
  periodList: planning.selectors.getPeriodList(state),
  allDimensionsList: configuration.selectors.getAllDimensionsList(state),
  currencyList: configuration.selectors.getCurrencyList(state),
  commentsList: configuration.selectors.getCommentsList(state),
  globalBudgetKpi: planning.selectors.getGlobalBudgetKpi(state),
  loggedUser: login.selectors.getWhoAmI(state),
})

const mapDispatchToProps = {
  // fetchGlobalBudgetDetail: planning.actions.fetchGlobalBudgetDetail,
  fetchBudgetTypeList: configuration.actions.fetchBudgetTypeList,
  fetchAnalysisList: reports.actions.fetchAnalysisList,
  fetchGlobalBudgetDetailKPI: planning.actions.fetchGlobalBudgetDetailKPI,
  approveGlobalBudget: planning.actions.approveGlobalBudget,
  setDefaultBudget: planning.actions.setDefaultBudget,
  publishGlobalBudget: planning.actions.publishGlobalBudget,
  changeBudget: planning.actions.changeBudget,
  fetchGlobalBudgetEvolutionTable: planning.actions.fetchGlobalBudgetEvolutionTable,
  fetchGlobalBudgetComparisonTable: planning.actions.fetchGlobalBudgetComparisonTable,
  unApplyRule: planning.actions.unApplyRule,
  applyRule: planning.actions.applyRule,
  fetchAllDimensions: configuration.actions.fetchAllDimensions,
  fetchDataEvolutionByOverallBudget: planning.actions.fetchDataEvolutionByOverallBudget,
  fetchDataComparativeByOverallBudget: planning.actions.fetchDataComparativeByOverallBudget,
  fetchCurrencyList: configuration.actions.fetchCurrencyList,
  fetchCommentsList: configuration.actions.fetchCommentsList,
  fetchGlobalBudgetKpi: planning.actions.fetchGlobalBudgetKpi,
  applyUnappluMassiveGlobalBudget: planning.actions.applyUnappluMassiveGlobalBudget,
  shareLayout: control.actions.shareLayout,
}

GlobalBudgetDetail.propTypes = {
  isScreenLoading: PropTypes.bool,
  globalBudgetDetail: PropTypes.shape({
    status: PropTypes.string,
    budgets_ids: PropTypes.array,
    name: PropTypes.string,
  }),
  onRefresh: PropTypes.func,
  fetchBudgetTypeList: PropTypes.func,
  analysisList: PropTypes.shape({
    count: PropTypes.number,
  }),
  fetchAnalysisList: PropTypes.func,
  approveGlobalBudget: PropTypes.func,
  setDefaultBudget: PropTypes.func,
  publishGlobalBudget: PropTypes.func,
  periodList: PropTypes.array,
  changeBudget: PropTypes.func,
  fetchDataEvolutionByOverallBudget: PropTypes.func,
  fetchDataComparativeByOverallBudget: PropTypes.func,
  applyRule: PropTypes.func,
  unApplyRule: PropTypes.func,
  fetchAllDimensions: PropTypes.func,
  allDimensionsList: PropTypes.array,
  fetchCurrencyList: PropTypes.func,
  currencyList: PropTypes.shape({
    data: PropTypes.array,
  }),
  fetchCommentsList: PropTypes.func,
  commentsList: PropTypes.array,
  fetchGlobalBudgetKpi: PropTypes.func,
  globalBudgetKpi: PropTypes.array,
  tabKey: PropTypes.any,
  setTabKey: PropTypes.func,
  loggedUser: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(GlobalBudgetDetail)
